import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=8b24ae70&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b24ae70')) {
      api.createRecord('8b24ae70', component.options)
    } else {
      api.reload('8b24ae70', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=8b24ae70&", function () {
      api.rerender('8b24ae70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SqYtVAP1mkdl/JS/childrenage.vue"
export default component.exports